import "./App.css";

// The Falcondale marketing site is served directly from /public/index.html
// as a fully static HTML/CSS/JS experience. React mounts to an empty,
// hidden #root element and intentionally renders nothing so the underlying
// static markup is displayed as-is.
function App() {
  return null;
}

export default App;
